import img from "../../assets/bg-form.webp";

export default function ContactForm() {
	return (
		<div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-slate-900 py-20">
			<div className="absolute inset-0 w-full h-full">
				<div
					className="w-full h-full bg-cover bg-center bg-fixed"
					style={{ backgroundImage: `url(${img})` }}
					role="img"
				/>
				<div className="absolute inset-0 bg-black/60" />
			</div>
			<div className="relative z-10 w-full max-w-lg p-8 mx-4 bg-white/10 backdrop-blur-sm rounded-lg shadow-2xl">
				<h2 className="text-3xl font-bold text-white mb-6 text-center">
					Contáctanos
				</h2>
				<p className="text-white/80 mb-6 text-center">
					Envíanos un mensaje y te responderemos a la brevedad.
				</p>
				<form className="space-y-4">
					<input
						type="text"
						placeholder="Nombre"
						className="w-full p-3 bg-white/10 border border-white/30 rounded-md text-white placeholder-white/70 focus:outline-none focus:border[#cbbca3] focus:ring-1 focus:ring-[#cbbca3] transition duration-200"
					></input>
					<input
						type="email"
						placeholder="Email"
						className="w-full p-3 bg-white/10 border border-white/30 rounded-md text-white placeholder-white/70 focus:outline-none focus:border[#cbbca3] focus:ring-1 focus:ring-[#cbbca3] transition duration-200"
					></input>
					<textarea
						placeholder="Mensaje"
						rows={5}
						className="w-full p-3 bg-white/10 border border-white/30 rounded-md text-white placeholder-white/70 focus:outline-none focus:border[#cbbca3] focus:ring-1 focus:ring-[#cbbca3] transition duration-200"
					></textarea>
					<button
						type="button"
						className="w-full py-3 mt-4 bg-[#cbbca3] hover:bg-[#cbbca3] text-white font-semibold rounded-md transition duration-300 ease-out shadow-lg shadow-[#cbbca3]/50"
					>
						Enviar
					</button>
				</form>
			</div>
		</div>
	);
}
